module.exports = __webpack_public_path__ + "img/android_2.ace22d42.jpg";